import { render, staticRenderFns } from "./SocialStreamDefaultProducts.vue?vue&type=template&id=c57ddada"
import script from "./SocialStreamDefaultProducts.vue?vue&type=script&lang=ts"
export * from "./SocialStreamDefaultProducts.vue?vue&type=script&lang=ts"
import style0 from "./SocialStreamDefaultProducts.vue?vue&type=style&index=0&id=c57ddada&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports